function getNext(current, max) {
  return (current + 1) % max;
}

function getPrevious(current, max) {
  return current - 1 < 0 ? max - 1 : current - 1;
}

export { getNext, getPrevious };